// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__B6aCW","table":"Table_table__YUzYe","pointer":"Table_pointer__v3mni","statuses":"Table_statuses__zgD9m","statusesText":"Table_statusesText__XxzHw"};